import {includes, filter, map, findIndex} from 'lodash';
import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {downloadFile} from '../../common/util/file';

const INITIAL_STATE = {
  'loading': false,
  'creatingOrders': false,
  'downloading': false,
  'loadingOrderStatus': false,
  'cancelling': false,
  'list': [],
  'filteredList': [],
  'searchDate': '',
  'searchDateEnd': '',
  'page': 0,
  'pageSize': 20,
  'chassisMarked': [],
  'orderStatusList': [],
  'ordersMarked': [],
};

const updatePage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > pageSize * (pageNumber + 1)) {
    return [...list].slice(pageSize * pageNumber, pageSize * (pageNumber + 1));
  }
  return [...list].slice(pageNumber * pageSize);
};

const getOrdersGenerated = (chassisMarked, orders) => {
  const ordersGenerated = filter(orders, (elem) => {
    return elem.order !== null && includes(chassisMarked, elem.chassis);
  });
  return map(ordersGenerated, 'order');
};

function updateOrderInList(list, orderUpdated) {
  const newList = [...list];
  const index = findIndex(newList, {'order': orderUpdated.order});

  const newObject = {...newList[index]};
  newObject.status = orderUpdated.status;

  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
}

export const accessoriesOrders = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.RESTORE_ACCESSORIES_ORDERS_PAGE]: (state, action) => ({
      ...state,
      'loading': false,
      'creatingOrders': false,
      'downloading': false,
      'cancelling': false,
      'list': [],
      'filteredList': [],
      'searchDate': '',
      'searchDateEnd': '',
      'page': 0,
      'pageSize': 20,
      'chassisMarked': [],
      'ordersMarked': [],
    }),
    [ActionTypes.CLEAN_ACCESSORIES_ORDERS_LIST]: (state, action) => ({
      ...state,
      'list': [],
      'filteredList': [],
    }),
    [ActionTypes.CHANGE_ACCESSORIES_ORDERS_DATE]: (state, action) => ({
      ...state,
      'searchDate': action.payload,
      'list': [],
      'filteredList': [],
      'page': 0,
      'chassisMarked': [],
      'ordersMarked': [],
    }),
    [ActionTypes.CHANGE_ACCESSORIES_ORDERS_DATE_END]: (state, action) => ({
      ...state,
      'searchDateEnd': action.payload,
      'list': [],
      'filteredList': [],
      'page': 0,
      'chassisMarked': [],
      'ordersMarked': [],
    }),
    [ActionTypes.RESIZE_ACCESSORIES_ORDERS_PAGE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'page': 0,
      'filteredList': updatePage(state.list, 0, action.payload),
    }),
    [ActionTypes.CHANGE_ACCESSORIES_ORDERS_PAGE]: (state, action) => ({
      ...state,
      'page': action.payload,
      'filteredList': updatePage(state.list, action.payload, state.pageSize),
    }),
    [ActionTypes.FETCHING_ORDER_AND_TASK_STATUS]: (state, action) => ({
      ...state,
      'loadingOrderStatus': true,
    }),
    [ActionTypes.FETCHED_ORDER_AND_TASK_STATUS]: (state, action) => ({
      ...state,
      'loadingOrderStatus': false,
      'orderStatusList': action.response.data,
    }),
    [ActionTypes.FETCHED_ORDER_AND_TASK_STATUS_FAILED]: (state, action) => ({
      ...state,
      'loadingOrderStatus': false,
      'orderStatusList': [],
    }),
    [ActionTypes.LOADING_ACCESSORIES_ORDERS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.LOADED_ACCESSORIES_ORDERS]: (state, action) => ({
      ...state,
      'loading': false,
      'page': 0,
      'list': action.response.data,
      'filteredList': updatePage(action.response.data, 0, state.pageSize),
      'chassisMarked': action.payload ? [] : state.chassisMarked,
      'ordersMarked': action.payload ?
        [] :
        getOrdersGenerated(state.chassisMarked, action.response.data),
    }),
    [ActionTypes.LOADED_ACCESSORIES_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'page': 0,
      'list': [],
      'filteredList': [],
      'chassisMarked': [],
      'ordersMarked': [],
    }),
    [ActionTypes.GENERATING_ACCESSORIES_ORDERS]: (state, action) => ({
      ...state,
      'creatingOrders': true,
    }),
    [ActionTypes.GENERATED_ACCESSORIES_ORDERS]: (state, action) => ({
      ...state,
      'creatingOrders': false,
    }),
    [ActionTypes.GENERATED_ACCESSORIES_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'creatingOrders': false,
    }),
    [ActionTypes.PRINTING_ACCESSORIES_ORDERS]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.PRINTED_ACCESSORIES_ORDERS]: (state, action) => ({
      ...state,
      'downloading': false,
    }),
    [ActionTypes.PRINTED_ACCESSORIES_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'downloading': false,
    }),
    [ActionTypes.CHANGE_CHASSIS_MARKED]: (state, action) => ({
      ...state,
      'chassisMarked': action.payload,
    }),
    [ActionTypes.CHANGE_ORDERS_MARKED]: (state, action) => ({
      ...state,
      'ordersMarked': action.payload,
    }),
    [ActionTypes.DOWNLOADING_STOCK_TO_ORDER]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOADED_STOCK_TO_ORDER]: (state, action) => {
      if (action.payload.action === 'revert') {
        const baseUrl = process.env.REP_API_URL;
        const fileUrl = `${baseUrl}/accessories/orders/${action.payload.order}/parts/document`;
        downloadFile(fileUrl);
      }

      return {
        ...state,
        'downloading': false,
        'filteredList': [
          ...updateOrderInList(state.filteredList, action.response.data),
        ],
      };
    },
    [ActionTypes.DOWNLOADED_STOCK_TO_ORDER_FAILED]: (state, action) => ({
      ...state,
      'downloading': false,
    }),
    [ActionTypes.CANCELLING_ORDER]: (state, action) => ({
      ...state,
      'cancelling': true,
    }),
    [ActionTypes.CANCELLED_ORDER]: (state, action) => ({
      ...state,
      'cancelling': false,
    }),
    [ActionTypes.CANCELLED_ORDER_FAILED]: (state, action) => ({
      ...state,
      'cancelling': false,
    }),
  })(state, action);
};
